import { Box, Skeleton } from '@mantine/core'

import classes from './OpportunityPickerModal.module.scss'

export function OpportunityOptionsSkeleton() {
  return (
    <Box>
      {[1, 2, 3].map(i => (
        <Box key={i} className={classes.ResultSkeleton}>
          <Skeleton circle width={18} height={18} style={{ marginRight: '0.5rem' }} />
          <Skeleton width={48} height={48} />

          <Box>
            <Skeleton width={200} height={16} style={{ marginBottom: '0.25rem' }} />
            <Skeleton width={250} height={16} />
          </Box>
        </Box>
      ))}
    </Box>
  )
}
